import React from 'react';

export function Card({
  children,
  itemId,
  className,
}: {
  children: JSX.Element;
  itemId: string;
  className: string;
}) {
  return (
    <div data-testid="item" className={className}>
      {children}
    </div>
  );
}
